import React, { useState } from 'react';
import { Modal, Button, Input, Icon } from 'antd';

import { REVOKE_EXCHANGE_KEY, REVOKE_MASTER_KEY } from '../../config/media';
import { RevokeKeyWrapper } from './style';
import { MailOutlined, WarningFilled } from '@ant-design/icons';

const RevokeKeyModal = ({ visible, revokedData, step, handleStep, onOk, onCancel, getVerificationCode }) => {
    const [isDisabled, setDisable] = useState(true);
    const [revokeData, setRevokeData] = useState({});

    const handleInput = (e) => {
        if (e.target.value === "I UNDERSTAND") {
            setDisable(false)
        } else {
            setDisable(true)
        }
    };

    const maxLengthCheck = (object) => {
        if (object.target.value.length > object.target.maxLength) {
            object.target.value = object.target.value.slice(0, object.target.maxLength)
        }
    };

    const handleChange = (name, value) => {
        setRevokeData({ ...revokeData, [name]: value });
    };

    const handle2faProceed = () => {
        getVerificationCode();
        handleStep(4);
    };

    const renderBody = () => {
        switch (step) {
            case 2:
                return (
                    <RevokeKeyWrapper>
                        <div className="step-2-container">
                            <div className="header-txt">Revoke exchange key</div>
                            <div className="subTitle">Exchange key:</div>
                            <div>{revokedData && revokedData.apiKey ? revokedData.apiKey : null}</div>
                            <div className="subTitle mt-2">Exchange secret key:</div>
                            <div>{revokedData && revokedData.secret ? revokedData.secret : null}</div>
                            {revokedData && revokedData.type === 'main'
                                ?
                                <div className='warning-section'>
                                    <WarningFilled />
                                    <div className='warning-txt'><b>Warning:</b> This is the main key used to access the network.</div>
                                </div>
                                : null
                            }
                            <div className="btn-wrapper">
                                <Button
                                    type='primary'
                                    onClick={() => handleStep(1)}
                                >
                                    Back
                                </Button>
                                <Button
                                    type='primary'
                                    onClick={() => handleStep(3)}
                                >
                                    Confirm
                                </Button>
                            </div>
                        </div>
                    </RevokeKeyWrapper>
                )
            case 3:
                return (
                    <RevokeKeyWrapper>
                        <div className="step-3-container">
                            <div className="header-txt">Revoke exchange key</div>
                            <div>
                                Please acknowledge that you understand the
                                possible ramifications of revoking your exchange key.
                            </div>
                            <div className="inner-content">
                                <div>Type 'I UNDERSTAND' to confirm</div>
                                <Input onChange={handleInput} />
                            </div>
                            <div className="btn-wrapper">
                                <Button
                                    type='primary'
                                    onClick={() => handleStep(2)}
                                >
                                    Back
                                </Button>
                                <Button
                                    type='primary'
                                    onClick={handle2faProceed}
                                    disabled={isDisabled}
                                >
                                    I understand. Proceed.
                                </Button>
                            </div>
                        </div>
                    </RevokeKeyWrapper>
                )
            case 4:
                return (
                    <RevokeKeyWrapper>
                        <div className='input-wrapper warning-wrapper'>
                            <div>
                                <div className='verification-wrapper'>
                                    <div className='d-flex'>
                                        <MailOutlined />
                                        <p className='sub-header'>
                                            <b>Input you security codes</b>
                                        </p>
                                    </div>
                                </div>
                                <p>A unique code was sent to your email that is required to finish the process. Please input the code below to proceed.</p>
                                <div className='sub-header'>Input code</div>
                                <Input
                                    prefix={<MailOutlined />}
                                    className='twoFA-input'
                                    placeholder="Input the code sent to your email"
                                    onChange={(e) => handleChange('email_code', e.target.value)}
                                />
                                <div className='sub-header'>Enter two-factor authentication (2FA)</div>
                                <Input
                                    prefix={
                                        <Icon
                                            type="lock"
                                            style={{ color: 'rgba(0,0,0,.25)' }}
                                        />
                                    }
                                    type="number"
                                    className='twoFA-input'
                                    placeholder="Enter 6-digit code"
                                    maxLength="6"
                                    onInput={maxLengthCheck}
                                    onChange={(e) => handleChange('otp_code', e.target.value)}
                                />
                            </div>
                            <div className="flex-content">
                                <Button
                                    block
                                    type='primary'
                                    onClick={() => handleStep(3)}
                                >
                                    Back
                                </Button>
                                <div className="seperator"></div>
                                <Button
                                    block
                                    type='primary'
                                    onClick={() => onOk(revokeData)}
                                    disabled={!revokeData.email_code || !revokeData.otp_code}
                                >
                                    Proceed
                                </Button>
                            </div>
                        </div>
                    </RevokeKeyWrapper>
                )
            case 1:
            default:
                return (
                    <RevokeKeyWrapper className={revokedData && revokedData.type === 'main' ? "terminate-wrapper" : ""}>
                        <div className="step-1-container">
                            {revokedData && revokedData.type === 'main'
                                ?
                                <div>
                                    <div className="img-wrapper">
                                        <img src={REVOKE_MASTER_KEY} className="revoke-masterKey-img" alt="revoke-key-img" />
                                    </div>
                                    <div className="header-txt">Revoke main exchange key</div>
                                    <div className="info-txt">
                                        Revoking your main key will disrupt your live exchange and is an action that can have consequences.
                                    </div>
                                </div>
                                :
                                <div>
                                    <div className="img-wrapper">
                                        <img src={REVOKE_EXCHANGE_KEY} className="revoke-key-img" alt="revoke-key-img" />
                                    </div>
                                    <div className="header-txt">Revoke standard key</div>
                                    <div className="info-txt">
                                        This may cause disruption to users of this key. Are you sure you want to proceed?
                                    </div>
                                </div>
                            }
                            <div className="btn-wrapper">
                                <Button
                                    type='primary'
                                    className={revokedData && revokedData.type === 'main' ? "close-btn" : ""}
                                    onClick={onCancel}
                                >
                                    Back
                                </Button>
                                <Button
                                    type='primary'
                                    className={revokedData && revokedData.type === 'main' ? "proceed-btn" : ""}
                                    onClick={() => handleStep(2)}
                                >
                                    I understand. Proceed.
                                </Button>
                            </div>
                        </div>
                    </RevokeKeyWrapper>
                )
        }
    }

    return (
        <Modal
            visible={visible}
            onCancel={onCancel}
            footer={null}
            bodyStyle={{
                padding: '0px',
            }}
            wrapClassName={
                revokedData && revokedData.type === 'main'
                    ? "terminate-modal-wrapper"
                    : ""
            }
        >
            {renderBody()}
        </Modal>
    )
}

export default RevokeKeyModal